"use client";

import type {
  GetParameters,
  UseOpenApiInfiniteQueryOptions,
} from "@packages/sdk";
import {
  getRequestNextPageParam,
  useOpenApiInfiniteQuery,
} from "@packages/sdk";

export const KEY_COMMUNITIES_ADMIN_USERS_BASE =
  "communities-admin-users" as const;
const urlBackendPath = "/communities/{community_id}/admin/users" as const;

type QueryParameters = GetParameters<typeof urlBackendPath>["query"];

export const keyCommunitiesAdminUsers = (
  props: QueryParameters & { id: number },
) => [
  KEY_COMMUNITIES_ADMIN_USERS_BASE,
  props.id.toString(),
  props.filter_by_role_id ?? "",
  props.filter_by_is_admin ?? "",
  props.search ?? "",
  props.sort_by ?? "",
  props.sort_direction ?? "",
];

export const useRequestCommunitiesAdminUsers = ({
  params,
  ...props
}: Partial<UseOpenApiInfiniteQueryOptions<typeof urlBackendPath>>) => {
  return useOpenApiInfiniteQuery({
    ...props,
    getNextPageParam: (lastPage, _allPages, lastPageParam: number) =>
      getRequestNextPageParam({
        total: lastPage.total,
        lastPageParam,
        pageSize: 50,
      }),
    initialPageParam: 0,
    params,
    queryKey: keyCommunitiesAdminUsers({
      id: params?.path?.community_id,
      ...params?.query,
    }),
    urlBackendPath,
  });
};
